import {
  UpdateVariableCompensationPayload,
  MutationUpdateVariableCompensationArgs,
} from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { VariableCompensationFragment } from "~/shared/fragments/VariableCompensationFragment"

const UPDATE_VARIABLE_COMPENSATION_MUTATION = gql`
  mutation UpdateVariableCompensation($input: UpdateVariableCompensationInput!) {
    updateVariableCompensation(input: $input) {
      errors
      existingVariableCompensation {
        ...VariableCompensationFragment
      }
    }
  }
  ${VariableCompensationFragment}
`

export const useEditVariableCompensationMutation = (
  options: InjectedOptions<
    { updateVariableCompensation: UpdateVariableCompensationPayload },
    MutationUpdateVariableCompensationArgs
  >,
) =>
  useMutation(UPDATE_VARIABLE_COMPENSATION_MUTATION, {
    ...options,
  })
